export default "__VITE_ASSET__CRabpTTo__"